import { render } from "./PopupBox.vue?vue&type=template&id=8cc0338c"
import script from "./PopupBox.vue?vue&type=script&lang=js"
export * from "./PopupBox.vue?vue&type=script&lang=js"

import exportComponent from "/Users/benjamin/Sites/hyper-v2/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__